'use client';

import { exposeClassnames as classnames } from '@stadionhq-v3/utilities';
import { VideoPlaylistBlock, VideoBlocksProps } from '@stadionhq-v3/base-ui';
import styles from './videoBlocks.module.scss';

const VideoBlocks = ({
  /* props */
  classNames,
  type,
  carousel,
  ...props
}: VideoBlocksProps) => {
  const classes = classnames(
    [styles.tokens, styles.videoBlocks, styles[type]],
    classNames
  );

  return (
    <VideoPlaylistBlock
      classNames={[classes]}
      type={type}
      carousel={{
        ...carousel,
        options: {
          breakpoints: {
            0: {
              fixedWidth: '244px',
              gap: '16px',
            },
            1439: {
              fixedWidth: '292px',
              gap: '32px',
            },
          },
        },
      }}
      {...props}
    />
  );
};

export default VideoBlocks;
